module.exports = __webpack_public_path__ + "static/media/continuous-delivery.e2ddf5e2.png";